import { header } from './modules/header';
import { animation } from './modules/animation';
import { accordion } from './modules/accordion';
import { followBtn } from './modules/followBtn';
header();
animation();
accordion();
followBtn();

document.addEventListener('DOMContentLoaded', () => {
	const animations = document.querySelectorAll('.c-line-animation');

	animations.forEach(wrapper => {
		const paths = wrapper.querySelectorAll('path');

		paths.forEach((path, index) => {
		const length = path.getTotalLength();

		// 初期スタイルを設定
		path.style.strokeDasharray = length;
		path.style.strokeDashoffset = length;
		// path.style.transition = `stroke-dashoffset 1.5s ease ${index * 1.5}s`;
		});

		// IntersectionObserverで表示されたらアニメーション開始
		// const observer = new IntersectionObserver(entries => {
		// entries.forEach(entry => {
		// 	if (entry.isIntersecting) {
		// 	paths.forEach(path => {
		// 		path.style.strokeDashoffset = 0;
		// 	});
		// 	observer.unobserve(entry.target); // 一度のみ実行
		// 	}
		// });
		// });

		// observer.observe(wrapper);

		// 全ページで一度だけ実行
		if (!sessionStorage.getItem("hasSeenOpening")) {
			sessionStorage.setItem("hasSeenOpening", "true");
		}

	});
});
